import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Funciona si tengo muchos años sin dormir bien?',
    a: 'Sí. El ritmo circadiano se puede resetear a cualquier edad.'
  }, {
    q: '¿Tengo que dejar el café por completo?',
    a: 'No. Solo aprenderás a respetar la Ventana del Tinto.'
  }, {
    q: '¿Necesito comprar equipos caros?',
    a: 'Para nada. Todo lo que necesitas ya está en tu casa: agua, calcetines y una libreta.'
  }, {
    q: '¿Es seguro si tomo medicamentos para la tensión?',
    a: 'El protocolo es natural y basado en higiene de hábitos. Siempre recomendamos informar a tu médico de cualquier cambio en tus rutinas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 md:px-8 bg-warmWhite text-nightBlue" data-id="element-22">
      <div className="max-w-3xl mx-auto" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-24">
          <h2 className="font-playfair font-bold text-3xl md:text-4xl mb-4" data-id="element-25">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-nightBlueLighter mx-auto rounded-full" data-id="element-26" />
        </motion.div>

        <div className="space-y-4" data-id="element-27">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="border border-nightBlue/10 rounded-2xl overflow-hidden bg-white shadow-sm" data-id="element-28">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-29">
                <span className="font-montserrat font-semibold text-lg pr-4" data-id="element-30">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 text-nightBlueLighter transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-31" />
              </button>

              <AnimatePresence data-id="element-32">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-33">
                    <div className="px-6 pb-6 font-lato text-base text-nightBlue/80 leading-relaxed" data-id="element-34">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}